import { Weekday } from './type'

export const weekdays: Weekday[] = [
    { key: 'Su', value: 'S' },
    { key: 'Mo', value: 'M' },
    { key: 'Tu', value: 'T' },
    { key: 'We', value: 'W' },
    { key: 'Th', value: 'T' },
    { key: 'Fr', value: 'F' },
    { key: 'Sa', value: 'S' }
]
